import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["checkboxAll", "checkbox"];

  initialize() {
    this.toggle = this.toggle.bind(this);
    this.refresh = this.refresh.bind(this);
  }
  connect() {
    console.log("xx");
    if (!this.hasCheckboxAllTarget) return;
    this.checkboxAllTarget.addEventListener("change", this.toggle);
    this.checkboxTargets.forEach((checkbox) =>
      checkbox.addEventListener("change", this.refresh)
    );
    this.checkboxTargets.forEach((checkbox) =>
      checkbox.addEventListener("input", this.refresh)
    );
    this.refresh();
  }
  disconnect() {
    if (!this.hasCheckboxAllTarget) return;
    this.checkboxAllTarget.removeEventListener("change", this.toggle);
    this.checkboxTargets.forEach((checkbox) =>
      checkbox.removeEventListener("change", this.refresh)
    );
  }
  toggle(e) {
    console.log("yy");
    e.preventDefault();
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = e.target.checked;
    });
    this.checkboxTargets.forEach((checkbox) => {
      this.triggerInputEvent(checkbox);
    });
  }
  refresh() {
    const checkboxesCount = this.checkboxTargets.length;
    const checkboxesCheckedCount = this.checked.length;
    this.checkboxAllTarget.checked = checkboxesCheckedCount > 0;
    this.checkboxAllTarget.indeterminate =
      checkboxesCheckedCount > 0 && checkboxesCheckedCount < checkboxesCount;
  }
  triggerInputEvent(checkbox) {
    const event = new Event("input", { bubbles: false, cancelable: true });
    checkbox.dispatchEvent(event);
  }
  get checked() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }
  get unchecked() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.checked);
  }
}
